const wordCounter = () => {
    $(document).on('keyup paste', '.js-wordCounter__field', function(e) {
        const $field = $(this).closest('.js-wordCounter');
        const maxWords = parseFloat($(this).attr('data-words'));
        const value = e.target.value.split(" ").length;
        const cssClass = value > maxWords ? 'is-failed' : 'is-passed';

        if ( $field.find('.js-wordCounter__output').length < 1 ) {
            $field.append('<div class="js-wordCounter__output" />')
        }
        const output = `<span class="${cssClass}">${value}</span>/${maxWords}`;
        $field.find('.js-wordCounter__output').html(output)
    })
};

wordCounter();
